<template lang='pug'>
  // dialog
  v-dialog( content-class='white' fullscreen v-model='_show' )

    // toolbar
    v-toolbar( color='primary' dark flat )
      v-toolbar-title Árbol de cuentas
      v-spacer
      v-btn( color='accent' depressed @click='_show=false' ) salir &nbsp;
        v-icon close

    // tree
    v-treeview( class='pa-3' :items='tree' item-text='text' )
      template( slot='prepend' slot-scope='props' )
        v-btn( 
          icon 
          large
          v-if='selectable.includes(props.item.level)' 
          @click='handleClickItemIcon(props.item)' 
          )
          v-icon( color="secondary" ) send
</template>

<script>
export default {
  name: 'dialog-account-tree',
  props: {

    /**
     * @description
     */
    show: {
      type: Boolean,
      default: () => true,
    },

    /**
     * @description
     */
    accounts: {
      type: Array,
      default: () => [],
    },

    /**
     * @description
     */

    accountTypes: {
      type: Array,
      default: () => [],
    },

    /**
     * 
     */
    idx: {
      type: Number,
    },

    /**
     * 
     */
    root: {
      type: Array,
      default: () => [
        {
          code: '1.00.00.00',
          text: '1 - Total Activos',
          children: [],
        },
        {
          code: '2.00.00.00',
          text: '2 - Total Pasivos',
          children: [],
        },
        {
          code: '3.00.00.00',
          text: '3 - Estado de Resultados',
          children: [],
        },
        {
          code: '4.00.00.00',
          text: '4 - Gastos',
          children: [],
        },
      ],
    },

    /**
     * 
     */
    filtered: {
      type: Object,
      default: () => ({
        parentAccounts: [],
        childrenAccounts: [],
      })
    },

    /**
     * 
     */
    selectable: {
      type: Array,
      default: () => [3, 4],
    }
  },
  data() {
    return {
      tree: [],
    }
  },
  computed: {

    /**
     * @description
     */
    _show: {
      get: function() {
        return this.show
      },
      set: function(val) {
        this.$emit('show', val)
      },
    },
  },
  methods: {
    
    /**
     * @description
     * Filter items by no-empty parent id
     */
    filterChild(item) {
      return !!item.acc_parent_id
    },

    /**
     * @description
     * Filter items by empty parent id
     */
    filterParent(item) {
      return !item.acc_parent_id
    },

    /**
     * @description
     * Format account items (types and default)
     */
    formatAccount(accAccount) {

      // required data
      const accountCode     = accAccount.code
      const accountComment  = accAccount.comment
      const accountParentId = accAccount.acc_parent_id

      // set account text
      accAccount.text = `${ accountCode } - ${ accountComment }`

      // set empty account children
      if (!accountParentId) {
        accAccount.children = []
      }

      // returns account
      return accAccount
    },

    /**
     * @description
     * Handle click item icon event
     */
    handleClickItemIcon(item) {
      this.$emit('account:select', item.id)
      this._show = false
    },

    /**
     * @description
     * Nest items by code
     */
    nestByCode(parents, children, level, nested = []) {

      // required data
      parents.forEach((parent, i) => {
      
        // set parent
        nested[i] = parent
        nested[i].level = level - 1

        //
        children.forEach((child, j) => {

          // set child level
          child.level = level

          // set parent child
          if (child.code.charAt(0) === nested[i].code.charAt(0)) {
            nested[i].children.push(child)
          }
        })

        // sort children
        parent.children.sort(this.sortByCode)
      })

      // return nested
      return nested
    },

    /**
     * @description
     * Nest items by id
     */
    nestById(parents, children, attribute, level, nested = []) {

      // required data
      parents.forEach((parent, i) => {
      
        // set parent
        nested[i] = parent
        nested[i].level = level - 1

        //
        children.forEach((child, j) => {

          // set child level
          child.level = level

          // set parent child
          if (child[attribute] === nested[i].id) {
            nested[i].children.push(child)
          }
        })

        // sort children
        parent.children.sort(this.sortByCode)
      })

      // return nested
      return nested
    },

    // Most structure from inner to outer lvl in tree structure
    refresh() {

      // required data
      let accAccounts       = this.accounts.map(this.formatAccount)
      let accAccountsRoot   = this.root
      let accAccountsTypes  = this.accountTypes.map(this.formatAccount)

      // filtered data
      let accAccountsParents  = accAccounts.filter(this.filterParent)
      let accAccountsChildren = accAccounts.filter(this.filterChild)

      // required levels
      let accAccountsOfThirdLevel   = this.nestById(accAccountsParents, accAccountsChildren, 'acc_parent_id', 4, [])
      let accAccountsOfSecondLevel  = this.nestById(accAccountsTypes, accAccountsOfThirdLevel, 'acc_account_type_id', 3, [])
      let accAccountsOfFirstLevel   = this.nestByCode(accAccountsRoot, accAccountsOfSecondLevel, 2, [])

      // set tree
      this.tree = accAccountsOfFirstLevel
    },

    /**
     * @description
     * Sort items by code
     */
    sortByCode(current, next) {
      return current.code_int - next.code_int
    },
  },
  mounted() {
    this.refresh()
  },
  watch: {
    accounts() {
      this.refresh()
    },
  }
}
</script>